import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSubmitForgotPasswordMutation } from "../../Services/LoginAPI";
import "./style.css";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({ email: "", apiError: "" });

    const [loginUser, { isLoading }] = useSubmitForgotPasswordMutation();
    const [APIerror, setApiError] = useState("")
 
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let newErrors = { email: "", password: "", apiError: "" };

        if (!email.trim()) {
            newErrors.email = "Email is required.";
        } else if (!isValidEmail(email)) {
            newErrors.email = "Enter a valid email address.";
        }

        setErrors(newErrors);
        if (newErrors.email) return;

        try {
            let formData = { email };
            const response = await loginUser(formData).unwrap();
            const responseEmail = response?.email
            setTimeout(() => {
                navigate("/send-otp", { state: { email: responseEmail } });
            }, 1000);
        } catch (err) {
            console.error("Login failed:", err?.data?.error);
            setApiError(err?.data?.error || err?.data?.message)
            setErrors((prev) => ({
                ...prev,
                apiError: err.data?.error || "Invalid login credentials.",
            }));
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h2 className="text-center mb-4">Forgot Password</h2>
                <form onSubmit={handleSubmit}>
                    {/* Email Field */}
                    <div className="mb-3 text-start">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                            type="email"
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            id="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>


                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                    <div className="login-api-error">{APIerror}</div>
                </form>
            </div>
        </div>
    );
};

export default Login;
